import React, { useEffect, useRef, useState } from 'react'
import Toggle from 'components/atom/Toggle'

import { Modal } from 'components/layout/Modal'
import { PaymentModal } from 'components/payment/PaymentModal'
import useGetPaymentOrderRequests from 'hooks/query/useGetPaymentOrderRequests'
import {
  AffiliateBenefit,
  CouponBenefit,
  DefaultBenefit,
  InviteBenefit,
  PaymentOrderRequest,
} from 'service/payment'
import useGetPlans from 'hooks/query/plans/useGetPlans'
import useGetPlansPrice from 'hooks/query/plans/useGetPlansPrice'
import {
  SubscriptionPlan,
  SubscriptionType,
  subscriptionType,
} from 'service/plans'
import { useLocation, useNavigate } from 'react-router-dom'

import { Button } from 'components/atom/Button'
import { usePostExperiencePlan } from 'hooks/query/usePostExperiencePlan'
import { FreePlanModal } from 'components/FreePlanModal'
import {
  getLocalStorage,
  getUtmLocalStorage,
  saveLocalStorage,
  savePrevPath,
  UserType,
} from 'utils/common'
import classNames from 'classnames'

import { CashPaymentModal } from 'components/payment/CashPaymentModal'
import { useGetMyPoint } from 'hooks/query/point/useGetMyPoint'
import { RequestPurchasePoint } from 'service/point'
import { useGetPointOrderId } from 'hooks/query/point/usetGetPoinOrderId'
import { useSaveUtm } from 'hooks/query/useSaveUtm'
import { PromotionBanner } from 'components/affiliate/PromotionBanner'
import { isMobile } from 'react-device-detect'

import { PayBackBanner } from 'components/payback/PayBackBanner'
import { BrandPaymentModal } from 'components/payment/BrandPaymentModal'
import useGetBillingCustomerKey from 'hooks/query/brandpay/useGetBillingCustomerKey'
import useUserStore from 'store/useUserStore'
import { Banner } from 'components/freePlan/Banner'
import usePrevStore from 'store/usePrevStore'
import { Helmet } from 'react-helmet-async'
import { initiateCheckoutTrack } from 'utils/metaAd'
import { stringify } from 'querystring'
import { createLogger } from 'utils/logger'
import { ShortForm } from './components/ShortForm'
import { FunctionBox } from './components/FunctionBox'
import { FeatureBox } from './components/FeatureBox'
import { UploadGuide } from './components/UploadGuide'

const logger = createLogger('price-guide')
export const PriceGuide = () => {
  const { data: myPointData, refetch: getMyPointRefetch } = useGetMyPoint()
  const { mutate: pointOrderIdMutate } = useGetPointOrderId()
  const { mutate: saveUtmMutate } = useSaveUtm()
  const userInfo = useUserStore((state: any) => state.userInfo)
  const prevSet = usePrevStore((state: any) => state.set)
  const navigate = useNavigate()
  const meRefetch = useUserStore((state: any) => state.refetch)
  const location = useLocation()
  const { pathname } = useLocation()
  const params = new URLSearchParams(location.search)
  const payment = params.get('payment')

  const [paymentModal, setPaymentModal] = useState<boolean>(false)
  const [brandPaymentModal, setBrandPaymentModal] = useState<boolean>(false)
  const [isUpgrade, setUpgrade] = useState<boolean>(false)
  const [monthPriceValue, setMonthPriceValue] = useState(0)
  const [isPlan, setIsPlan] = useState<boolean>(false)
  const [isCashPaymentModal, setCashPaymentModal] = useState<boolean>(false)
  const [type, isType] = useState('annual')
  const [planIdValue, setPlanId] = useState(0)
  const [planPriceIdValue, setPlanPriceId] = useState(0)
  const [isToggled, setIsToggled] = useState(false)
  const [isMonth, setIsMonth] = useState<boolean>(false)
  const [isFreePlanModal, SetFreePlanModal] = useState<boolean>(false)
  const [requestPurchasePoint, setRequestPurchasePoint] =
    useState<RequestPurchasePoint>({ orderId: '' })
  const [paymentOrderRequest, setPaymentOrderRequest] =
    useState<PaymentOrderRequest>({
      orderId: '',
      productName: '',
      subscriptionType: '',
      price: 0,
      vat: 0,
      id: 0,
    })
  const [affiliateBenefit, setAffiliateBenefit] =
    useState<null | AffiliateBenefit>(null)
  const [couponBenefit, setCouponBenefit] = useState<null | CouponBenefit>(null)
  const [defaultBenefit, setDefaultBenefit] = useState<null | DefaultBenefit>(
    null
  )

  const [inviteBenefit, setInviteBenefit] = useState<null | InviteBenefit>(null)
  // Plan 및 subscriptionType에 따른 가격을 가져오는 쿼리
  const { isLoading, data: plans, refetch } = useGetPlans()
  const { mutate: experiencePlanMutate } = usePostExperiencePlan()

  const {
    isLoading: priceIsLoading,
    data: price,
    refetch: priceRefetch,
  } = useGetPlansPrice(type)

  const { mutate: getPaymentOrderRequestsMutate } = useGetPaymentOrderRequests()
  const { mutate: customerKeyMutate } = useGetBillingCustomerKey()
  const [customerKey, setCustomerKey] = useState<string>('')
  const getButtonLabel = ({
    userInfo,
    plan,
    type,
  }: {
    userInfo: any
    plan: any
    type: any
  }): string => {
    if (
      userInfo?.userType === UserType.USER ||
      !userInfo ||
      userInfo?.userType === UserType.체험
    ) {
      return plan?.name === '라이트' ||
        type === 'monthly' ||
        price?.benefitInfo?.description === 'USER_COUPON_ANNUAL_EXPIRE'
        ? '사용하기'
        : '선착순 페이백 받기'
    }

    if (
      userInfo?.subscriptions &&
      plan.id !== userInfo?.subscriptions?.planId
    ) {
      return '문의하기'
    }

    if (
      type === subscriptionType?.ANNUAL &&
      userInfo?.subscriptions?.subscriptionType === subscriptionType?.MONTHLY
    ) {
      return '업그레이드'
    }
    if (
      type === subscriptionType.MONTHLY &&
      userInfo?.subscriptions?.subscriptionType === subscriptionType?.MONTHLY &&
      price?.benefitInfo &&
      price.benefitType === 'coupon'
    ) {
      return '사용하기'
    }

    // 재결제 조건
    // subscriptions없고 couponBenefit있는데 , description이 USER_COUPON_ANNUAL_EXPIRE

    return '문의하기'
  }
  const isFreePlanOrUser = () => {
    if (!userInfo) {
      return true
    } else if (
      userInfo &&
      userInfo?.userType === UserType.USER &&
      !userInfo?.experiencedUser
    ) {
      return true
    }
    return false
  }

  const paybackCoupon = () => {
    const coupon = userInfo?.couponBenefit?.description

    if (!userInfo) {
      // 로그인 전
      return true
    } else if (
      userInfo?.userType === UserType.USER &&
      coupon === 'USER_COUPON_ANNUAL_EXPIRE'
    ) {
      return false
    } else if (
      // 로그인 후 체험이면서 사용전 / 일반유저
      (userInfo &&
        userInfo?.userType === UserType.체험 &&
        Number(userInfo?.usage?.usedCount) === 0) ||
      userInfo?.userType === UserType.USER
    ) {
      return true
    } else if (userInfo?.subscriptions?.subscriptionType === 'monthly') {
      //유저가 월간 플랜을 사용중
      return true
    }
    return false
  }

  const handleBrandPay = (
    planId: number,
    planPriceId: number,
    planPrice: SubscriptionPlan | null
  ) => {
    setPlanId(planId)
    setPlanPriceId(planPriceId)

    if (!userInfo?.userInfo) {
      saveLocalStorage('planId', planId)
      saveLocalStorage('planPriceId', planPriceId)
      saveLocalStorage('subscriptionType', type)
      savePrevPath(`/price-guide?payment=true`, prevSet)
      navigate('/sign-up')
      return
    } else if (type !== 'monthly') {
      return
    }

    if (
      !(
        userInfo?.userType === UserType.USER ||
        userInfo?.userType === UserType.체험
      )
    ) {
      setIsPlan(true)
      return
    }
    getPaymentOrderRequestsMutate(
      { planId, planPriceId },
      {
        onSuccess: (data) => {
          customerKeyMutate('', {
            onSuccess: (customerKey) => {
              setCustomerKey(String(customerKey))
              setPaymentOrderRequest(data.orderRequest)
              if (data.affiliateBenefit) {
                setAffiliateBenefit(data.affiliateBenefit)
              }
              if (data?.couponBenefit) {
                setCouponBenefit(data.couponBenefit)
              }
              if (data?.inviteBenefit) {
                setInviteBenefit(data.inviteBenefit)
              }
              setBrandPaymentModal(true)
              const planPrice = price?.prices.find((el) => el.id === planId)

              if (planPrice) {
                const value = planPrice?.planPrice[0].price
                const contentName = planPrice?.name
                const contentType = `plan_${planPrice?.id}_${planPrice?.planPrice[0]?.subscriptionType}`

                console.log('pixel initiateCheckoutTrack send! price modal')
                initiateCheckoutTrack({
                  value: Number(value),
                  contentName,
                  contentType,
                })
              }
            },
            onError: (e) => {
              console.log(e)
            },
          })
        },
        onError: (e) => {
          console.log(e)
        },
      }
    )
  }
  const getPaymentOrderRequests = (
    planId: number,
    planPriceId: number,
    planPrice: SubscriptionPlan | null
  ) => {
    setPlanId(planId)
    if (!userInfo?.userInfo) {
      saveLocalStorage('planId', planId)
      saveLocalStorage('planPriceId', planPriceId)
      saveLocalStorage('subscriptionType', type)

      savePrevPath(`/price-guide?payment=true`, prevSet)
      navigate('/sign-up')
      return
    }

    // 업그레이드 조건 클릭한 planId와 현재 사용중인 planId가 같을경우에는 상관없지
    if (
      userInfo?.subscriptions?.subscriptionType === subscriptionType.MONTHLY &&
      userInfo?.subscriptions?.planId === planId &&
      type === subscriptionType.ANNUAL
    ) {
      setUpgrade(true)
      setMonthPriceValue(Number(userInfo?.subscriptions?.price))
    } else if (
      // 월결제 달성 후 다시 월결제 조건
      userInfo?.usage?.isDone &&
      userInfo?.subscriptions?.planId === planId
    ) {
    } else {
      if (
        !(
          userInfo?.userType === UserType.USER ||
          userInfo?.userType === UserType.체험
        )
      ) {
        setIsPlan(true)
        return
      }
    }

    getPaymentOrderRequestsMutate(
      { planId, planPriceId },
      {
        onSuccess: (data) => {
          setPaymentOrderRequest(data.orderRequest)
          if (data.affiliateBenefit) {
            setAffiliateBenefit(data.affiliateBenefit)
          }
          if (data?.couponBenefit) {
            setCouponBenefit(data.couponBenefit)
          }
          if (data?.inviteBenefit) {
            setInviteBenefit(data.inviteBenefit)
          }
          if (data?.defaultBenefit && type === 'annual') {
            setDefaultBenefit(data.defaultBenefit)
          }
          setPaymentModal(true)
          const planPrice = price?.prices.find((el) => el.id === planId)

          if (planPrice) {
            const value = planPrice?.planPrice[0].price
            const contentName = planPrice?.name
            const contentType = `plan_${planPrice?.id}_${planPrice?.planPrice[0]?.subscriptionType}`

            console.log('pixel initiateCheckoutTrack send! price modal')
            initiateCheckoutTrack({
              value: Number(value),
              contentName,
              contentType,
            })
          }
        },
        onError: (e) => {
          logger.error(JSON.stringify(e))
        },
      }
    )
  }
  const paymentFreePlan = () => {
    if (!userInfo?.userInfo) {
      navigate('/sign-up')
      return
    } else if (userInfo && userInfo?.userType === UserType.체험) {
      navigate('/video-editor')
      return
    }
    const utmData = getUtmLocalStorage()
    if (utmData?.utmSource) {
      utmData.trackType = 'FREE_EXPERIENCE'
      saveUtmMutate(utmData, {
        onSuccess: () => {},
        onError: () => {},
      })
    }
    experiencePlanMutate('', {
      onSuccess: (data) => {
        refetch()
        meRefetch()
        navigate('/video-editor')
      },
      onError: (e) => {
        logger.error(JSON.stringify(e))
        setIsPlan(true)
      },
    })
  }
  const handleToggle = () => {
    setIsToggled(!isToggled)
    setIsMonth(!isMonth)
  }

  //* 캐시충전 버튼
  const handleCashPaymentModal = () => {
    if (userInfo) {
      pointOrderIdMutate(undefined, {
        onSuccess: (data) => {
          setRequestPurchasePoint(data)
          setCashPaymentModal(true)
        },
        onError: () => {},
      })
    } else {
      savePrevPath('/shortform-price-guide?payment=true', prevSet)
      navigate('/sign-up')
    }
  }

  useEffect(() => {
    if (isMonth) {
      isType(subscriptionType.MONTHLY)
    } else {
      isType(subscriptionType.ANNUAL)
    }
  }, [isToggled])

  useEffect(() => {
    priceRefetch()
  }, [type])

  useEffect(() => {
    if (paymentModal || isFreePlanModal) {
      document.body.classList.add('overflow-hidden') // Tailwind 유틸리티 클래스 사용
    } else {
      document.body.classList.remove('overflow-hidden')
    }
  }, [paymentModal, isFreePlanModal])
  useEffect(() => {
    const prevPlanId = getLocalStorage('planId')
    const prevPlanPriceId = getLocalStorage('planPriceId')
    const prevSubscriptionType = getLocalStorage('subscriptionType')

    if (
      payment &&
      userInfo &&
      prevPlanId &&
      prevPlanPriceId &&
      prevSubscriptionType
    ) {
      params.delete('payment')
      const updatedSearch = params.toString()
      const updatedPath = `${location.pathname}${
        updatedSearch ? `?${updatedSearch}` : ''
      }`
      navigate(updatedPath, { replace: true })
      if (prevSubscriptionType === subscriptionType.ANNUAL) {
        getPaymentOrderRequests(prevPlanId, prevPlanPriceId, null)
      } else if (prevSubscriptionType === subscriptionType.MONTHLY) {
      }
    }
  }, [payment, userInfo])

  return (
    <>
      <Helmet>
        <title>상품 영상 플랜 가격안내</title>
        <meta
          name="description"
          content="연결제, 월구독 다양한 옵션으로 나에게 맞는 플랜을 선택하세요!"
        />
        <link
          rel="canonical"
          href="https://fastcut.fastseller.shop/price-guide"
        />
      </Helmet>
      <div className="md:max-w-[1000px] max-w-[375px]  my-0 mx-auto flex flex-col items-center md:gap-[20px] gap-4">
        <div className="flex w-[343px] md:w-full flex-col items-center">
          {pathname !== '/my-payments' && (
            <p className="md:text-[40px] text-[32px] font-bold ">
              상품 영상 플랜 가격 안내
            </p>
          )}
          {(isFreePlanOrUser() || paybackCoupon()) && (
            <div className="flex flex-col md:gap-2 md:mt-10 my-4">
              {isFreePlanOrUser() && !isMobile && (
                <>
                  <Banner
                    prevpath="/challenge"
                    paymentFreePlan={paymentFreePlan}
                    SetFreePlanModal={SetFreePlanModal}
                  />
                </>
              )}
              {paybackCoupon() && <PayBackBanner width={1000} gap={169} />}
            </div>
          )}

          <p className=" leading-[21.6px] text-center text-[18px] md:mt-[40px] mt-6">
            합리적인 요금의 패스트컷 사용 플랜. <br />
            영상 업로드 계획과 가격 할인 등을 고려해서
            <span className="text-main font-bold">
              {' '}
              플랜과 사용 기간을 선택
            </span>
            하세요!
          </p>

          {isMobile ? (
            <>
              {' '}
              <div className="flex flex-col mt-6">
                <div className="flex justify-center">
                  {' '}
                  <a
                    className="bg-[#ED3023] text-white flex gap-2 items-center px-2 rounded-[6px] h-[32px] w-[188px] font-bold"
                    href="https://angelleague.notion.site/AI-15bba20e97f3809b8d33d7b08aaacd3f"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src="assets/img/icon_youtube.png"
                      alt="youtube"
                      width={26}
                      height={26}
                    />{' '}
                    <span>{`상품 영상 샘플 보기 >`}</span>
                  </a>
                </div>
                <div className="flex w-[335px] md:w-full md:h-auto h-[70px] md:items-center items-end justify-center  relative">
                  <button
                    className={classNames(
                      ' h-[41px]   font-bold text-[14px] absolute left-0 rounded-[10px] flex items-center gap-1 justify-center',
                      {
                        'text-white bg-[#FD6767] w-[260px] z-50':
                          type === 'annual',
                        'bg-[#EEF1F7] text-[#8F929B] w-[246px] z-0':
                          type !== 'annual',
                      }
                    )}
                    onClick={() => {
                      handleToggle()
                    }}
                  >
                    연 결제
                    <p className="   w-[102px] h-[16px] rounded-[6px] font-bold text-[#FD6767] bg-[#FFE8E8] text-[10px] flex justify-center items-center">
                      ~ 40% 할인 무이자할부
                    </p>
                    <p className="   w-[64px] h-[16px]  rounded-[6px] font-bold text-[#FF8800] bg-[#FFF7E8] text-[10px] flex items-center justify-center">
                      🎁 럭키드로우
                    </p>
                  </button>
                  <button
                    className={classNames(
                      'h-[41px]  font-bold text-[14px] absolute right-0 rounded-[10px]',
                      {
                        'text-white bg-[#FD6767] ] w-[104px] z-50':
                          type === 'monthly',
                        'bg-[#EEF1F7] text-[#8F929B] w-[97px]  z-0':
                          type !== 'monthly',
                      }
                    )}
                    onClick={() => {
                      handleToggle()
                    }}
                  >
                    월 구독
                  </button>
                </div>
              </div>
            </>
          ) : (
            <>
              {' '}
              <div className="flex w-[335px] md:w-full md:h-auto h-[86px] md:items-center items-end justify-between   mt-6">
                <a
                  className="bg-[#ED3023] text-white flex gap-2 items-center px-2 rounded-[6px] h-[32px] font-bold"
                  href="https://angelleague.notion.site/AI-15bba20e97f3809b8d33d7b08aaacd3f"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="assets/img/icon_youtube.png"
                    alt="youtube"
                    width={26}
                    height={26}
                  />{' '}
                  <span>{`상품 영상 샘플 보기 >`}</span>
                </a>
                <Toggle isToggled={isToggled} handleToggle={handleToggle} />
              </div>
            </>
          )}
        </div>
        {type === 'monthly' && price?.benefitType === 'coupon' && (
          <div>
            <button
              className="bg-main text-white md:w-[460px] w-[335px] h-[42px] rounded-[40px]"
              style={{
                background: 'linear-gradient(to right, #52EBA6, #005EE1)',
              }}
            >
              <span className="font-[800] font-[Tenada]">
                {price.benefitInfo?.couponDescription}
              </span>
            </button>
          </div>
        )}

        {type === 'annual' && price?.benefitType === 'coupon' && (
          <div>
            <button
              className="bg-main text-white md:w-[460px] w-[335px] h-[42px] rounded-[40px]"
              style={{
                background: 'linear-gradient(to right, #6095FF, #D512E7)',
              }}
            >
              <span className="font-[800] font-[Tenada]">
                {price.benefitInfo?.couponDescription}
              </span>
            </button>
          </div>
        )}
        {price?.benefitType === 'invite' && !userInfo?.alreadyBenefit && (
          <div className="w-[335px] text-[14px] md:text-base md:w-[460px] h-[42px] md:mb-10">
            <button
              className="text-white font-[800] flex items-center justify-center w-full rounded-[40px] h-full "
              style={{
                fontFamily: 'Tenada',
                background:
                  'linear-gradient(to right, rgba(96, 149, 255, 1),rgba(213, 18, 231, 1))',
              }}
            >
              <span className="mt-0.5">
                {' '}
                지금 바로 첫 결제하시면,10% 추가 캐시 적립!
              </span>
            </button>
          </div>
        )}

        {userInfo?.affiliate.point && (
          <PromotionBanner
            daysLeft={userInfo?.affiliate?.point?.daysLeft}
            hoursLeft={userInfo?.affiliate?.point?.hoursLeft}
            affiliateImage={userInfo?.affiliate?.point?.affiliateImage}
            affiliateDescription={
              userInfo?.affiliate?.point?.affiliateDescription
            }
          />
        )}
        <div className="flex flex-col w-auto md:flex-row gap-[8px]">
          {plans?.map((plan, i) => {
            if (plan.id === 5) {
              return (
                <>
                  <div className="flex items-center">
                    <div className="flex justify-center items-center">
                      <div className="flex flex-col items-center space-y-2">
                        {Array.from({ length: 15 }, (_, i) => (
                          <div
                            key={i}
                            className="w-[3px] h-6 bg-[#D9D9D9] rounded-full "
                          />
                        ))}
                      </div>
                    </div>
                  </div>
                  <ShortForm
                    userInfo={userInfo}
                    plan={plan}
                    price={price}
                    type={type}
                    paybackCoupon={paybackCoupon}
                    getPaymentOrderRequests={getPaymentOrderRequests}
                    handleBrandPay={handleBrandPay}
                  />
                </>
              )
            }
            return (
              <div
                className={classNames(
                  'border rounded-[20px] border-[#EEF1F7] shadow-main flex flex-col md:w-[328px] w-[343px]  gap-[32px] px-[24px] py-[40px] ',
                  {
                    'border-[4px] border-main':
                      !userInfo ||
                      userInfo?.userType === UserType.USER ||
                      userInfo?.userType === UserType.체험
                        ? plan.name === '프리미엄'
                        : plan.id === userInfo?.subscriptions.planId,
                  }
                )}
                key={i}
              >
                <div className="flex flex-col items-center">
                  <p className="font-bold text-main text-[24px] flex gap-[2px]">
                    롱폼 {plan?.name}
                    {plan.name === '프리미엄' && (
                      <div>
                        <div className="h-[4px]"></div>
                        <div className="text-[14px] font-bold bg-error text-[#FFFFFF] rounded-[4px]  h-[17px] flex items-center p-[2px]">
                          <div>BEST</div>
                        </div>
                      </div>
                    )}
                  </p>
                  {price?.benefitType === 'invite' && (
                    <p className="text-error font-bold">
                      {' '}
                      첫 결제 +{' '}
                      {`${price.prices[
                        i
                      ].planPrice[0].bonusPoint?.toLocaleString()}`}{' '}
                      캐시 보너스
                    </p>
                  )}

                  {!!price?.prices?.length &&
                  price.prices[i].planPrice[0].subscriptionType ===
                    'monthly' ? (
                    <>
                      {price?.benefitType === 'coupon' && (
                        <>
                          <p className="text-error font-bold text-[18px] h-[19px]">
                            {userInfo?.subscriptions?.planName === plan?.name &&
                              '미션 성공 20% 할인'}
                          </p>
                          <s className="font-bold text-[#8F929B] text-[24px] h-[29px]">
                            {userInfo?.subscriptions?.planName === plan?.name &&
                              `   ₩${price.prices[
                                i
                              ]?.planPrice[0].originPrice.toLocaleString()}`}
                          </s>{' '}
                        </>
                      )}
                      <p>
                        <span className="font-bold text-[32px]">
                          ₩
                          {!!price?.prices?.length &&
                            price.prices[
                              i
                            ]?.planPrice[0].price.toLocaleString()}
                        </span>{' '}
                        <span className="font-bold "> /월(VAT 별도)</span>
                      </p>
                    </>
                  ) : (
                    <>
                      {/* annual 가격 폼 */}
                      <p className="flex flex-col items-center">
                        {/* <span className="font-bold text-[18px] text-[#2E343D]">
                        <s>
                          {!!price?.length &&
                            price[
                              i
                            ]?.planPrice[0]?.originPrice.toLocaleString()}
                          원
                        </s>
                      </span> */}
                        {/* <span className="font-bold text-[18px] text-error">
                        100명 한정 가격
                      </span> */}
                        {userInfo?.affiliate?.plan?.length > 0 && (
                          <>
                            <p className="text-error font-bold text-[18px]">
                              {userInfo?.affiliate?.plan[0]?.name}
                            </p>
                          </>
                        )}

                        <p>
                          {' '}
                          <s className="font-bold text-[#8F929B] text-[24px]">
                            ₩
                            {!!price?.prices?.length &&
                              price.prices[
                                i
                              ]?.planPrice[0].monthlyPrice.toLocaleString()}
                            {` `}
                          </s>{' '}
                          <s className="text-[16px] text-[#8F929B] font-bold">
                            /월
                          </s>
                        </p>

                        <p>
                          <span className="font-bold text-[32px]">
                            ₩
                            {!!price?.prices?.length &&
                              Number(
                                price.prices[i]?.planPrice[0].descriptionPrice
                              ).toLocaleString()}
                          </span>
                          <span className="font-bold"> /월(VAT 별도)</span>
                        </p>
                      </p>
                      <span className="text-[18px] text-[#8F929B]">
                        ₩
                        {!!price?.prices?.length &&
                          Number(
                            price.prices[i]?.planPrice[0].price
                          ).toLocaleString()}
                        /1년
                      </span>
                    </>
                  )}

                  {type === 'annual' && paybackCoupon() && (
                    <div
                      className={classNames(
                        'flex justify-center h-[48px] mt-2 cursor-pointer'
                      )}
                      onClick={() => {
                        navigate('/challenge')
                      }}
                    >
                      {plan.name !== '라이트' && paybackCoupon() && (
                        <img
                          src="assets/img/coupon/payback.png"
                          alt=""
                          className="w-[119px] h-[48px]"
                        />
                      )}
                    </div>
                  )}
                </div>

                <div>
                  <Button
                    className="bg-main w-full h-[48px] border-none rounded-[48px] text-white font-bold disabled:opacity-[0.5]"
                    onClick={() => {
                      if (type === 'annual') {
                        getPaymentOrderRequests(
                          plan.id,
                          !!price?.prices?.length
                            ? price.prices[i]?.planPrice[0].id
                            : 0,
                          !!price?.prices?.length
                            ? price.prices[i]?.planPrice[0]
                            : null
                        )
                      } else {
                        handleBrandPay(
                          plan.id,
                          !!price?.prices?.length
                            ? price.prices[i]?.planPrice[0].id
                            : 0,
                          !!price?.prices?.length
                            ? price.prices[i]?.planPrice[0]
                            : null
                        )
                      }
                    }}
                  >
                    {getButtonLabel({ userInfo, plan, type })}
                  </Button>
                  {}
                </div>
                <div className="flex flex-col">
                  <div className="plan flex flex-col md:h-[250px] h-auto ">
                    <p className="font-bold text-[18px] flex items-center gap-[5px] mb-[24px]">
                      <img
                        src="assets/img/check_circle.png"
                        alt="check_circle"
                        width={24}
                        height={24}
                      />
                      {type === 'annual' ? <>12개월 사용</> : <>1개월 사용</>}
                    </p>

                    {plan?.planDetail.map((el, index) => {
                      return (
                        <FeatureBox
                          planDetail={el}
                          index={index}
                          planId={plan.id}
                        />
                      )
                    })}
                  </div>
                  <hr className="mt-[10px] mb-[30px] h-auto" />
                  <div className="flex flex-col">
                    {plan?.planDetail.map((el, index) => {
                      return (
                        <FunctionBox
                          planDetail={el}
                          index={index}
                          planId={plan.id}
                        />
                      )
                    })}
                  </div>
                </div>
              </div>
            )
          })}
        </div>
        {/* 컴포넌트 위치 */}
        <UploadGuide />

        <div className="md:w-[1000px] w-[335px] md:h-[208px] p-5 md:px-[32px] md:py-[16px] flex flex-col md:flex-row items-center justify-between border-[2px] border-[#735CFF] rounded-[20px]">
          <div className="flex flex-col items-center">
            <p className="font-bold md:text-[24px] text-[16px]">
              커스텀 솔루션
            </p>
            <p className="font-[800] text-[#735CFF]  md:text-[32px] text-[20px]">
              고객 맞춤 플랜
            </p>
          </div>
          <div className="md:text-[18px] text-[14px] font-bold flex flex-col gap-[16px] mt-[32px] md:mt-0">
            <p className="flex items-center gap-2 md:text-[18px] text-[14px]">
              {' '}
              <img
                src="assets/img/check_circle_purple.png"
                alt="check"
                width={24}
                height={24}
              />
              브랜드, 플랫폼, 에이전시 고객을 위한 맞춤형 솔루션
            </p>
            <p className="flex items-center gap-2 md:text-[18px] text-[14px]">
              {' '}
              <img
                src="assets/img/check_circle_purple.png"
                alt="check"
                width={24}
                height={24}
              />
              고객의 필요에 따라 사이트 고객 맞춤 작업을 지원
            </p>
            <p className="flex items-center gap-2 md:text-[18px] text-[14px]">
              {' '}
              <img
                src="assets/img/check_circle_purple.png"
                alt="check"
                width={24}
                height={24}
              />
              <a
                href="https://angelleague.notion.site/AI-115ba20e97f3803d91cdc2c647149c3e"
                target="_blank"
                rel="noreferrer"
                className="text-[#735CFF] underline"
              >{`고객 맞춤 플랜 상세 내용 확인 >>`}</a>
            </p>
          </div>
          <div className="flex flex-col gap-[8px] font-bold text-[18px] mt-[32px] md:mt-0">
            <a
              href="http://pf.kakao.com/_CFxfHxj/chat"
              target="_blank"
              rel="noreferrer"
              className="w-full"
            >
              <button
                className="w-[264px] h-[60px]  border-[#735CFF] border-[2px] rounded-[40px] bg-[#735CFF] text-white text-[18px]"
                onClick={() => {}}
              >
                카톡으로 문의하기
              </button>
            </a>
          </div>
        </div>

        {paymentModal && (
          <PaymentModal
            setPaymentModal={setPaymentModal}
            paymentOrderRequest={paymentOrderRequest}
            affiliateBenefit={affiliateBenefit}
            inviteBenefit={inviteBenefit}
            affiliatePlan={userInfo?.affiliate?.plan}
            couponBenefit={couponBenefit}
            defaultBenefit={defaultBenefit}
            setCouponBenefitData={setCouponBenefit}
            setAffiliateBenefitData={setAffiliateBenefit}
            setDefaultBenefitData={setDefaultBenefit}
            userInfo={userInfo?.userInfo}
            planId={planIdValue}
            type={type}
            upgrade={isUpgrade}
            monthPrice={monthPriceValue}
          />
        )}
        {brandPaymentModal && (
          <BrandPaymentModal
            setPaymentModal={setBrandPaymentModal}
            paymentOrderRequest={paymentOrderRequest}
            affiliateBenefit={affiliateBenefit}
            inviteBenefit={inviteBenefit}
            affiliatePlan={userInfo?.affiliate?.plan}
            couponBenefit={couponBenefit}
            defaultBenefit={defaultBenefit}
            setCouponBenefitData={setCouponBenefit}
            setAffiliateBenefitData={setAffiliateBenefit}
            setDefaultBenefitData={setDefaultBenefit}
            userInfo={userInfo?.userInfo}
            planId={planIdValue}
            planPriceId={planPriceIdValue}
            type={type}
            upgrade={isUpgrade}
            monthPrice={monthPriceValue}
            customerKey={customerKey}
          />
        )}

        {isCashPaymentModal && (
          <CashPaymentModal
            setCashPaymentModal={setCashPaymentModal}
            userInfo={userInfo?.userInfo}
            affiliatePoint={userInfo?.affiliate?.point}
            userCurrentPoint={myPointData.totalPoint}
            requestPurchasePoint={requestPurchasePoint}
          />
        )}

        {isPlan && (
          <Modal isModal={isPlan}>
            <div className="bg-white w-[400px] h-[184px] p-[20px] border-t rounded-t-[20px]">
              <div className="flex flex-col items-center justify-center h-full gap-[24px]">
                <p className="font-bold text-[18px]">
                  이미 사용중인 플랜이 있어요!
                </p>
                <div>
                  <p className="">
                    사용중인 플랜의 기한이 지난 후<br /> 새로운 플랜을
                    결제해주시거나 <br />
                    패스트컷에 따로 문의해주세요!
                  </p>
                </div>
              </div>
            </div>
            <div className="w-[400px] bg-main h-[60px] border-b border-main rounded-b-[20px] flex justify-center items-center ">
              <button
                className="text-white w-[400px] font-bold"
                onClick={() => {
                  setIsPlan(false)
                }}
              >
                확인
              </button>
            </div>
          </Modal>
        )}

        {isFreePlanModal && (
          <FreePlanModal
            isFreePlanModal={isFreePlanModal}
            setFreePlanModal={SetFreePlanModal}
          />
        )}
      </div>
    </>
  )
}
